export const INITIAL_DIAGRAM_DIFF_STATE = Object.freeze({
  diagramDiff: null,
});

export default function createDiagramDiffSlice(set, get) {
  return {
    ...INITIAL_DIAGRAM_DIFF_STATE,
    setDiagramDiff: (diagramDiff) => {
      console.debug('DesignStore.setDiagramDiff', diagramDiff);
      return set({
        diagramDiff: diagramDiff ? { ...diagramDiff } : null,
      });
    },
    setDiagramDiffFocusChanges: (focusChanges) => {
      console.debug('DesignStore.setDiagramDiffFocusChanges', focusChanges);
      const current = get().diagramDiff;
      if (!current) return;
      return set({ diagramDiff: { ...current, focusChanges } });
    },
  };
}
